const Price=
    {
        breakfast:1500,
        lunch:2400,
        dinner:3000
        
    }
    
export default Price;